module.exports = __webpack_public_path__ + "static/media/jcm1.fbdd42af.png";